import React, { useState, useEffect } from "react";
import "./VamoosSettings.css";

const VamoosSettings = ({ isOpen, onClose, onSave }) => {
  const [operatorCode, setOperatorCode] = useState("vmd");
  const [referenceCode, setReferenceCode] = useState("vl1234");

  // Load saved codes from localStorage when modal opens
  useEffect(() => {
    if (isOpen) {
      const savedOperatorCode =
        localStorage.getItem("vamoosOperatorCode") || "vmd";
      const savedReferenceCode =
        localStorage.getItem("vamoosReferenceCode") || "vl1234";

      setOperatorCode(savedOperatorCode);
      setReferenceCode(savedReferenceCode);
    }
  }, [isOpen]);

  const handleSave = () => {
    // Save to localStorage
    localStorage.setItem("vamoosOperatorCode", operatorCode);
    localStorage.setItem("vamoosReferenceCode", referenceCode);

    // Call parent callback with new codes
    onSave(operatorCode, referenceCode);

    // Close modal
    onClose();
  };

  const handleCancel = () => {
    // Reset to saved values
    const savedOperatorCode =
      localStorage.getItem("vamoosOperatorCode") || "vmd";
    const savedReferenceCode =
      localStorage.getItem("vamoosReferenceCode") || "vl1234";

    setOperatorCode(savedOperatorCode);
    setReferenceCode(savedReferenceCode);

    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="vamoos-settings-overlay" onClick={handleCancel}>
      <div
        className="vamoos-settings-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="vamoos-settings-header">
          <h3>Vamoos Settings</h3>
          <button
            className="vamoos-settings-close"
            onClick={handleCancel}
            title="Close"
          >
            ×
          </button>
        </div>

        <div className="vamoos-settings-body">
          <p className="vamoos-settings-description">
            Configure the operator and reference codes to test your EWA with
            different trips.
          </p>

          <div className="vamoos-form-group">
            <label htmlFor="operatorCode">Operator Code</label>
            <input
              type="text"
              id="operatorCode"
              value={operatorCode}
              onChange={(e) => setOperatorCode(e.target.value)}
              placeholder="e.g., vmd"
              className="vamoos-input"
            />
            <span className="vamoos-input-hint">
              The operator code identifies the tour operator
            </span>
          </div>

          <div className="vamoos-form-group">
            <label htmlFor="referenceCode">Reference Code</label>
            <input
              type="text"
              id="referenceCode"
              value={referenceCode}
              onChange={(e) => setReferenceCode(e.target.value)}
              placeholder="e.g., vl1234"
              className="vamoos-input"
            />
            <span className="vamoos-input-hint">
              The reference code identifies the specific trip
            </span>
          </div>
        </div>

        <div className="vamoos-settings-footer">
          <button
            className="vamoos-btn vamoos-btn-cancel"
            onClick={handleCancel}
          >
            Cancel
          </button>
          <button className="vamoos-btn vamoos-btn-save" onClick={handleSave}>
            Save & Reload Preview
          </button>
        </div>
      </div>
    </div>
  );
};

export default VamoosSettings;
